import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-016f1662"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "DialogBody" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "D-Flex W-100",
  style: {"text-align":"left","margin-bottom":"15px","white-space":"nowrap"}
}, null, -1))
const _hoisted_5 = { class: "DialogSection" }
const _hoisted_6 = {
  class: "DialogSection FlexColumn",
  style: {"width":"60%","flex":"auto"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_9 = {
  key: 1,
  class: "CookiesDialogFooter"
}
const _hoisted_10 = {
  class: "F-Bold",
  style: {"margin":"auto 1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesDropInputObject = _resolveComponent("CookiesDropInputObject")!
  const _component_CookiesDescriptionBox = _resolveComponent("CookiesDescriptionBox")!
  const _component_CookiesNumberInput = _resolveComponent("CookiesNumberInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.Access(_ctx.DialogData.Editing ? 'HR_Deductions_Edit': 'HR_Deductions_Create'))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: 'CookiesDialog_' + _ctx.DialogIndex,
          class: "CookiesDialogdBody"
        }, [
          (_ctx.Saving)
            ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
            : _createCommentVNode("", true),
          (_ctx.Loading.length > 0)
            ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 1 }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_CookiesDropInputObject, {
                    Name: _ctx.Translate('Employee Name'),
                    Default: '',
                    Options: _ctx.Employees,
                    RowHeight: '3em',
                    Selectors: [['Name'], ['ID']],
                    CookiesInvalidInput: !_ctx.MEMRead('D_Deduction_Employee') && _ctx.MEMRead('D_Deduction_Employee') === '',
                    ErrorData: _ctx.ErrorsVisibilty && (!_ctx.MEMRead('D_Deduction_Employee') && _ctx.MEMRead('D_Deduction_Employee') === ''),
                    Res: 'D_Deduction_Employee'
                  }, null, 8, ["Name", "Options", "CookiesInvalidInput", "ErrorData"]),
                  _createVNode(_component_CookiesDescriptionBox, {
                    Placeholder: _ctx.Translate('Reason'),
                    Res: 'D_Deduction_Reason'
                  }, null, 8, ["Placeholder"]),
                  _createVNode(_component_CookiesNumberInput, {
                    Step: 5,
                    MinWidth: '3em',
                    Placeholder: 'Salary Deduction',
                    Unit: _ctx.PriceUnit,
                    CookiesInvalidInput: !_ctx.MEMRead('D_Deduction_SalaryDeduction') && _ctx.MEMRead('D_Deduction_SalaryDeduction') === '',
                    ErrorData: _ctx.ErrorsVisibilty && (!_ctx.MEMRead('D_Deduction_SalaryDeduction') && _ctx.MEMRead('D_Deduction_SalaryDeduction') === ''),
                    Res: 'D_Deduction_SalaryDeduction',
                    Default: 0
                  }, null, 8, ["Unit", "CookiesInvalidInput", "ErrorData"]),
                  _createVNode(_component_CookiesNumberInput, {
                    Step: 1,
                    MinWidth: '3em',
                    Placeholder: 'Hour Deduction',
                    Unit: _ctx.Translate('Hour'),
                    CookiesInvalidInput: !_ctx.MEMRead('D_Deduction_HourDeduction') && _ctx.MEMRead('D_Deduction_HourDeduction') === '',
                    ErrorData: _ctx.ErrorsVisibilty && (!_ctx.MEMRead('D_Deduction_HourDeduction') && _ctx.MEMRead('D_Deduction_HourDeduction') === ''),
                    Res: 'D_Deduction_HourDeduction',
                    Default: 0
                  }, null, 8, ["Unit", "CookiesInvalidInput", "ErrorData"]),
                  _createVNode(_component_CookiesNumberInput, {
                    Step: 1,
                    MinWidth: '3em',
                    Placeholder: 'Day Deduction',
                    Unit: _ctx.Translate('Day'),
                    CookiesInvalidInput: !_ctx.MEMRead('D_Deduction_DayDeduction') && _ctx.MEMRead('D_Deduction_DayDeduction') === '',
                    ErrorData: _ctx.ErrorsVisibilty && (!_ctx.MEMRead('D_Deduction_DayDeduction') && _ctx.MEMRead('D_Deduction_DayDeduction') === ''),
                    Res: 'D_Deduction_DayDeduction',
                    Default: 0
                  }, null, 8, ["Unit", "CookiesInvalidInput", "ErrorData"])
                ])
              ]),
              _hoisted_7,
              _hoisted_8
            ])
          ])
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.Access(_ctx.DialogData.Editing ? 'HR_Deductions_Edit': 'HR_Deductions_Create'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
              style: {"background":"var(--colorr1)"},
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Cancel')), 1),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.SaveData && _ctx.SaveData(...args))),
              class: "F-Bold CookiesButton DialogFooterButton BGMain"
            }, _toDisplayString(_ctx.Translate('Save')), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}